import { resolveBlob } from '@/utils/index'
import { axios } from '@/utils/request'
export function previewFileLists(fileList) {
    let arr = []
    for(let i=0;i<fileList.length;i++){
        arr.push(new Promise((resolve,rej)=>{
            let path = '/' + fileList[i].url.split('/')[0] + '/'
            let fileName = fileList[i].url.substring(fileList[i].url.indexOf("/")+1)
              axios({
                    url: `/file/file/download?bucketName=${fileList[i].types}&path=${path}&fileName=${fileName}`,
                    method: 'post',
                     responseType: 'blob', // 必须要写
                   }).then((res)=>{
                       fileList[i].imgUrl = window.URL.createObjectURL(res)
                        resolve(fileList[i])
                   })

        }))
    }
    return Promise.all(arr)
}
export function previewFileLists2(fileList) {
    let arr = []
    for(let i=0;i<fileList.length;i++){
        arr.push(new Promise((resolve,rej)=>{
            let path = '/' + fileList[i].split('/')[0] + '/'
            let fileName = fileList[i].substring(fileList[i].indexOf("/")+1)
              axios({
                    url: `/file/file/download?bucketName=${fileList[i].types}&path=${path}&fileName=${fileName}`,
                    method: 'post',
                     responseType: 'blob', // 必须要写
                   }).then((res)=>{
                       fileList[i].imgUrl = window.URL.createObjectURL(res)
                        resolve(fileList[i])
                   })

        }))
    }
    return Promise.all(arr)
}